export const aboutInfo = {
  brandName: '宅宅资源库',
  brandIntro: '宅宅资源库成立于2024年，由一群热爱二次元文化的资深宅友共同创建。我们致力于打造中文互联网上最全面、最优质的二次元资源聚合平台，让每一位宅友都能在这里找到心仪的内容。从动漫到漫画，从游戏到轻小说，从音乐到壁纸，宅宅资源库汇聚了海量宅系资源，以精细的分类、及时的更新和友好的社区氛围，成为了数百万宅友的首选资源平台。',
  mission: '让每一个宅友都能轻松找到想要的二次元资源，享受纯粹的宅文化乐趣。',
  vision: '成为华语圈最受信赖和喜爱的二次元资源聚合与文化交流平台。',
  stats: [
    { label: '注册用户', value: '128万+' },
    { label: '资源总数', value: '5,937+' },
    { label: '日均访问', value: '35万+' },
    { label: '社区帖子', value: '86万+' },
  ],
  milestones: [
    { year: '2024.03', event: '宅宅资源库正式上线，首发500+动漫资源' },
    { year: '2024.06', event: '用户突破10万，新增漫画与轻小说分类' },
    { year: '2024.09', event: '社区功能上线，宅友可以自由交流讨论' },
    { year: '2024.12', event: '用户突破50万，资源总数超过2000+' },
    { year: '2025.03', event: '推出移动端适配版本，支持手机浏览下载' },
    { year: '2025.06', event: '用户突破100万，成为华语最大二次元资源平台' },
    { year: '2025.10', event: '游戏资源与音乐资源分类正式上线' },
    { year: '2026.02', event: '平台全面升级，引入AI智能推荐系统' },
  ],
  testimonials: [
    { name: '樱花飘落的季节', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20chibi%20style%2C%20simple%20clean%20background%2C%20kawaii%20Japanese%20illustration&width=80&height=80&seq=avatar-test-01&orientation=squarish', text: '自从发现了宅宅资源库，再也不用到处搜资源了！更新超快，分类也很清晰，强烈推荐给所有二次元同好！', role: '资深宅友 · 使用1年' },
    { name: '夜の猫', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20cat%20girl%20avatar%20with%20black%20hair%20and%20cat%20ears%2C%20chibi%20style%2C%20simple%20clean%20background%2C%20kawaii%20Japanese%20illustration&width=80&height=80&seq=avatar-test-02&orientation=squarish', text: '资源质量真的高，BD片源+外挂字幕，强迫症表示非常满意。社区的求资源效率也是一流的！', role: '动漫收藏家 · 使用8个月' },
    { name: '次元旅人K', avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20boy%20avatar%20with%20silver%20hair%20and%20glasses%2C%20chibi%20style%2C%20simple%20clean%20background%2C%20Japanese%20illustration&width=80&height=80&seq=avatar-test-03&orientation=squarish', text: '轻小说区简直是宝藏！很多冷门作品在这里都能找到完整的翻译版本，感谢宅宅资源库的编辑团队！', role: '轻小说爱好者 · 使用6个月' },
  ],
  contact: {
    email: 'contact@zhazhai.moe',
    qq: '1234567890',
    wechat: 'zhazhai_official',
    telegram: 't.me/zhazhai_resources',
    address: '中国上海市浦东新区张江高科技园区',
  },
};